"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.U64 = void 0;
const common_sdk_1 = require("@orca-so/common-sdk");
exports.U64 = common_sdk_1.U64_MAX.add(common_sdk_1.ONE);
//# sourceMappingURL=constants.js.map